import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import SaudeService from '../../../services/saude'
import Profissional from './profissional';
import LocalService from '../../../services/local';

const ListarProfissionais = () => {

    const [profissionais, setProfissionais] = useState([]);
    const [locais, setLocais] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchProfissionais() {
        await montaSelectLocais();
        const response = await SaudeService.listarProfs();
        if (response.data.length >= 1) {
            setProfissionais(response.data)
            setVazio(false)
        } else {
            setProfissionais([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchProfissionais();
    }, []);

    const montaSelectLocais = async () => {
        const prod = await LocalService.categorias({secretaria: "Secretaria Municipal de Saúde e Prevenção a Dependência Química"});
        setLocais(prod.data)
    }

    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setProfissionais={setProfissionais}
                    setVazio={setVazio}
                    locais={locais}
                    profissionais={profissionais}
                    fetchProfissionais={fetchProfissionais}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <h2>Profissionais da Rede Municipal de Saúde em Macuco</h2>
                    <Row xs={1}>
                        {profissionais.map((prof, index) =>
                            <Profissional
                                prof={prof}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarProfissionais;